import { useState, useEffect } from 'react'
import { motion, AnimatePresence, useScroll } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { useCart } from '../context/CartContext'
import { stickyCart } from '../data/productLine'

export default function StickyCart() {
  const { t, i18n } = useTranslation()
  const es = i18n.language?.startsWith('es')
  const { scrollYProgress } = useScroll()
  const { items, itemCount, total, openCart } = useCart()
  const [show, setShow] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    return scrollYProgress.on('change', (v) => {
      if (!dismissed) setShow(v > 0.08)
    })
  }, [scrollYProgress, dismissed])

  function handleDismiss(e) {
    e.preventDefault()
    e.stopPropagation()
    setDismissed(true)
    setShow(false)
  }

  function handleClick(e) {
    if (itemCount > 0) {
      e.preventDefault()
      openCart()
    }
  }

  const label = itemCount > 0
    ? `${itemCount} ${itemCount === 1 ? t('cart.item') : t('cart.items')} — €${(total / 100).toFixed(0)}`
    : t('stickyCart.label')

  const vatLabel = t('cart.vatIncl')
  const price = itemCount > 0 ? t('cart.viewCart') : t('stickyCart.price')
  const href = itemCount > 0 ? '#' : stickyCart.href

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="sticky-cart"
          style={{ x: '-50%' }}
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.33, 1, 0.68, 1] }}
        >
          <a href={href} className="sticky-cart-inner" onClick={handleClick}>
            <span className="sticky-cart-text">{label}</span>
            <span className="sticky-cart-divider" />
            <span className="sticky-cart-price">{price}<span style={{ fontSize: '0.7em', opacity: 0.5, marginLeft: 4 }}>{vatLabel}</span></span>
            <span className="sticky-cart-arrow">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5">
                <line x1="0" y1="7" x2="12" y2="7" />
                <polyline points="7,2 12,7 7,12" />
              </svg>
            </span>
            {itemCount > 0 && (
              <motion.span
                key={itemCount}
                className="sticky-cart-badge"
                initial={{ scale: 1.4, opacity: 0.7 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ type: 'spring', stiffness: 500, damping: 15 }}
              >
                {itemCount}
              </motion.span>
            )}
          </a>
          <button
            className="sticky-cart-dismiss"
            onClick={handleDismiss}
            aria-label="Dismiss"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.5">
              <line x1="2" y1="2" x2="10" y2="10" />
              <line x1="10" y1="2" x2="2" y2="10" />
            </svg>
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
